import React, { useEffect, useState } from "react";
import { GetSignatureApi } from "../../api/request/signature/signature";
import columns from "../../columns/signature/signature";
import SkeletonTable from "../../components/table/SkeletonTable";
import moment from "moment";
import Eye from "../../assets/View";
import GlobalTooltip from "../../components/common/GlobalTooltip";

const SignatureReport = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getSignature = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetSignatureApi();
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            FileName: <p className="capitalize">{item?.file?.service_name_slug}</p>,
            FileNum: item?.file?.file_number,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
            statusText: (
              <div
                className={`font-bold uppercase ${item?.status === "signed" ? "text-green-500" : "text-red-500"
                  }`}
              >
                {item?.status}
              </div>
            ),
            action: (
              <GlobalTooltip title={"View Signature Report"}>
                <a
                  href={item?.path || "#"}
                  target={item?.path && "_blank"}
                  className="font-medium text-blue-500 w-fit inline-block"
                >
                  <Eye />
                </a>
              </GlobalTooltip>
            ),
          };
        })
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSignature();
  }, []);
  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className="title">Signature</p>
      </div>
      <div className="mt-5">
        <SkeletonTable columns={columns} data={data} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default SignatureReport;
